module.exports = __webpack_public_path__ + "static/media/thumbs-up.65cd434c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/thumbs-up.svg
// module id = 179
// module chunks = 1